import {ApiService} from '../../../services/api.service';
import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {UserInfo} from '../../../services/api.service';

import {Router} from '@angular/router';
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import { ButtonComponent } from '@components/button/button.component';
import { AlertComponent } from '@components/alert/alert.component';
import { CommonModule } from '@angular/common';
import { BadgeStatusComponent } from '@components/badge-status/badge-status.component';
import { CosentinoSvgComponent } from '@components/cosentino-svg/cosentino-svg.component';
import { SlickCarouselModule } from 'ngx-slick-carousel'; // Ensure this import is added
import { Claim } from 'app/interfaces/claim.interface';
import { ClaimActions } from 'app/interfaces/claim-actions';
import { ClaimService } from 'app/services/claim.service';


@Component({
    selector: 'app-claim-card',
    templateUrl: './claim-card.component.html',
    styleUrl: './claim-card.component.scss',
    standalone: true,
    imports: [TranslateModule, ButtonComponent, AlertComponent, CommonModule, BadgeStatusComponent, CosentinoSvgComponent, SlickCarouselModule],
    encapsulation: ViewEncapsulation.None,
})
export class ClaimCardComponent implements OnInit {
    @Input() claim: Claim
    @Output() clickCustom = new EventEmitter()
    @Output() onClaimDelete = new EventEmitter()
    noExiste: boolean = false
    userInfo: UserInfo
    isModalOpen = false
    itemIdToDelete: number
    slideConfig = {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        infinite: true,
        autoplay: false,
        dotsClass: 'slick-dots-we',
        nextArrow:
            '<svg style="position:absolute;top:42%;right:0;z-index:10;cursor:pointer;" c-cosentinoSvg_chevronRight="" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M9.4002 17.3L8.7002 16.6L13.3002 12L8.7002 7.39995L9.4002 6.69995L14.7002 12L9.4002 17.3Z" fill="#232323"/></path></svg>',
        prevArrow:
            '<svg style="position:absolute;top:42%;z-index:10;cursor:pointer;" c-cosentinoSvg_chevronLeft="" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M14.0002 17.3L8.7002 12L14.0002 6.69995L14.7002 7.39995L10.1002 12L14.7002 16.6L14.0002 17.3Z" fill="#232323"/></path></svg>',
    }
    products = [
        { title: 'Producto 1', image: 'https://via.placeholder.com/100' },
        { title: 'Producto 2', image: 'https://via.placeholder.com/100' },
        { title: 'Producto 3', image: 'https://via.placeholder.com/100' },
    ]
    claimActions: ClaimActions

    constructor(private router: Router, private api: ApiService, private translate: TranslateService, private claimService: ClaimService) {}

    ngOnInit() {
        this.api.userInfo.subscribe((userInfo) => (this.userInfo = userInfo))

        this.claimActions = this.getClaimActions(this.claim)
    }
    goToClaimDetail() {
        this.router.navigate(['/claim-detail/', this.claim.id])
    }
    deleteClaim() {
        console.log('Deleting claim with ID:', this.claim.id)
        this.api.deleteClaim(this.claim.id).subscribe((response) => {
            console.log('Claim deleted successfully', response)
            this.onClaimDelete.emit()
        })
    }
    getClaimActions(claim: Claim): ClaimActions {
        return this.claimService.getClaimActions(claim)
    }
    getDocument = (caseId: string, documentId: string, title: string, extension: string) => {
        this.api.downloadClaimDocument(caseId, documentId).subscribe((blob) => {
            const blobUrl = window.URL.createObjectURL(blob)

            const a = document.createElement('a')
            a.href = blobUrl
            a.download = title + '.' + extension
            a.click()

            // Limpieza
            window.URL.revokeObjectURL(blobUrl)
        })
    }
    downloadAllDocuments = (caseId: string) => {
        this.api.downloadAllClaimDocuments(caseId).subscribe((blob) => {
            const blobUrl = window.URL.createObjectURL(blob)

            const a = document.createElement('a')
            a.href = blobUrl
            a.download = caseId + '.zip'
            a.click()

            // Limpieza
            window.URL.revokeObjectURL(blobUrl)
        })
    }
}
